var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReportDetailImage = function SvgReportDetailImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.488 2.903H4.514A3.517 3.517 0 0 0 1 6.416v4.503a3.517 3.517 0 0 0 3.514 3.513h6.973A3.517 3.517 0 0 0 15 10.919V6.417a3.516 3.516 0 0 0-3.512-3.514m2.275 8.016a2.28 2.28 0 0 1-2.275 2.275H4.514a2.28 2.28 0 0 1-2.276-2.275V6.417a2.28 2.28 0 0 1 2.276-2.275h6.973a2.28 2.28 0 0 1 2.275 2.275z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.974a2.697 2.697 0 0 0-2.693 2.693 2.697 2.697 0 0 0 2.694 2.694 2.697 2.697 0 0 0 2.693-2.694 2.697 2.697 0 0 0-2.693-2.693m0 4.15a1.46 1.46 0 0 1-1.455-1.457c0-.802.653-1.455 1.456-1.455s1.456.653 1.456 1.455c0 .804-.653 1.456-1.456 1.456M6.37 2.237h3.26A.618.618 0 1 0 9.63 1H6.37a.618.618 0 1 0 0 1.238"
  }))));
};
export default SvgReportDetailImage;